import type { GuardianPlayerLevelDetailStatus } from '@/features/guardian-player/types';

const PIN_NAME_TO_IMAGE = {
  putting: 'Putting',
  aroundthegreen: 'ATG',
  knowledge: 'Know',
  mastery: 'Score',
  fullswing: 'Full_Swing',
  overall: 'Overall',
} as const;

type PinImageNameKey = keyof typeof PIN_NAME_TO_IMAGE;

function normalizePinImageNameKey(badgeName: string) {
  return badgeName.replace(/[\s_-]+/g, '').toLowerCase();
}

export function getGuardianPinImageName(badgeName: string) {
  const key = normalizePinImageNameKey(badgeName);
  if (key in PIN_NAME_TO_IMAGE) {
    return PIN_NAME_TO_IMAGE[key as PinImageNameKey];
  }
  return badgeName.trim().replace(/\s+/g, '_');
}

export function buildGuardianPinPicture(
  levelNumber: number,
  badgeName: string,
  status: GuardianPlayerLevelDetailStatus,
) {
  const pinImageName = getGuardianPinImageName(badgeName);

  switch (status) {
    case 'earned':
      return `LV${levelNumber}_${pinImageName}_guardian_completed.png`;
    case 'working':
      return `LV${levelNumber}_${pinImageName}_guardian_partial.png`;
    case 'notStarted':
    default:
      return `${pinImageName}_guardian_incompleted.png`;
  }
}
